import _ from 'lodash'

export function reverse<T>(arr: T[]) {
    let res = _.clone(arr)
    _.reverse(res)
    return res
}

export function notNil(o) {
    return !_.isNil(o)
}

export function isEmptyStringOrNil(o) {
    if (_.isString(o)) {
        o = _.trim(o)
    }
    if (o === '') {
        return true
    }
    return _.isNil(o)
}

export function toNumberOrNull(o) {
    if (o === '' || o === null) {
        return null
    }
    let res = _.toNumber(o)
    if (!_.isFinite(res)) {
        return null
    }
    return res
}

export function toIntegerStringOrNull(o) {
    if (o === '' || o === null) {
        return null
    }
    let res = _.toInteger(o)
    if (!_.isFinite(res)) {
        return null
    }
    return String(res)
}


export function maybeEmptyStringToNull(o) {
    if (o === '') {
        return null
    }
    return o
}

export function anyToBoolean(e) {
    if (_.isString(e)) {
        if (e.toLowerCase() === 'true') {
            return true
        }
        if (e.toLowerCase() === 'false') {
            return false
        }
    }
    return Boolean(e)
}

export function patchArrayRight<T>(array: T[], size: number, value = null) {
    array = array || []
    if (array.length >= size) {
        return array
    }
    return [...array, ...new Array(size - array.length).fill(value)]
}

export function groupToArrayBy<T, R>(arr: T[], fn: (item: T) => R) {
    let res: T[][] = []
    let lastItemGroup: T[] = []
    _.each(arr, item => {
        if (_.isEmpty(lastItemGroup)) {
            lastItemGroup.push(item)
        } else {
            if (fn(lastItemGroup[0]) === fn(item)) {
                lastItemGroup.push(item)
            } else {
                res.push(lastItemGroup)
                lastItemGroup = [item]
            }
        }
    })
    if (!_.isEmpty(lastItemGroup)) {
        res.push(lastItemGroup)
    }
    return res
}

export function groupToArrayWith<T, R>(arr: T[], fn: (acc: T[], item: T) => R) {
    let res: T[][] = []
    let lastItemGroup: T[] = []
    _.each(arr, item => {
        if (_.isEmpty(lastItemGroup)) {
            lastItemGroup.push(item)
        } else {
            if (fn(lastItemGroup, item)) {
                lastItemGroup.push(item)
            } else {
                res.push(lastItemGroup)
                lastItemGroup = [item]
            }
        }
    })
    if (!_.isEmpty(lastItemGroup)) {
        res.push(lastItemGroup)
    }
    return res
}

export function ensureField<T>(context: any, key: string, factory: () => T) {
    let res = _.get(context, key) as T
    if (res !== undefined) {
        return res!
    }
    res = factory()
    context[key] = res
    return res
}

/**
 * 修正 
 */
export function deepMap<T extends object>(content: T, path: string, fn): T {
    let data = _.get(content, path)
    let fixed = null
    if (_.isArray(data)) {
        fixed = _.map(data, fn)
    } else if (!_.isNil(data)) {
        fixed = fn(data)
    }
    _.set(content, path, fixed)
    return content
}

export function jsonSafeParse<T>(str: string): T {
    try {
        return JSON.parse(str) as T
    } catch (e) {
        console.error(e)
        return undefined
    }
}


export function invokeCommand(command) {
    if(command.fn) {
        command.fn()
    }
}